module.exports = __webpack_public_path__ + "img/img15.ae0980dd.svg";